const getEnergyStyle = (energyName) => {
      if (energyName.includes("Tuyệt mệnh") || energyName.includes("Họa hại") || energyName.includes("Ngũ quỷ") || energyName.includes("+0") || energyName.includes("kẹp 0")) {
        return { backgroundColor: "#ea4236" };
      } else if (energyName === "Phục vị" || energyName === "Phục vị kẹp 5" || energyName === "Phục vị +5") {
        return { backgroundColor: "#efb11e" };
      } else if (energyName === "Lục sát" || energyName === "Lục sát kẹp 5" || energyName === "Lục sát +5") {
        return { backgroundColor: "#ff6d00" };
      } else if (energyName.includes("Thiên y") || energyName.includes("Sinh khí") || energyName.includes("Diên niên")) {
        return { backgroundColor: "#33a854" };
      }
      return {};
    };
    
    export default getEnergyStyle;
